import type { ConsentState } from "~/lib/consent-region";
import { posthog, isPostHogBrowserEnabled } from "~/lib/posthog/client";

export type ConsentDecisionAction =
  | "accept_all"
  | "reject_optional"
  | "save_preferences";

export type ConsentSurface = "banner" | "management_page";

export function reportConsentBannerShown(surface: ConsentSurface) {
  if (!isPostHogBrowserEnabled()) {
    return;
  }

  posthog.capture("cookie_consent_banner_shown", { surface });
}

// Call before persistConsent: rejecting triggers posthog.reset() in the
// provider, and the decision must be stamped with the pre-reset identity.
export function reportConsentDecision(
  action: ConsentDecisionAction,
  consent: ConsentState,
  surface: ConsentSurface,
) {
  if (!isPostHogBrowserEnabled()) {
    return;
  }

  posthog.capture("cookie_consent_decision", {
    action,
    ad_consent: consent.adConsent,
    analytics_consent: consent.analyticsConsent,
    surface,
  });
}
